import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

const SalesTargetListDetails = () => {
  const columns = [
    { label: 'Name', value: 'name' },
    { label: 'Assigned To', value: 'assigned_to_name' },
    { label: 'Target Amount', value: 'target_amount' },
    { label: 'Period', value: 'period' },
    { label: 'Access Details', value: (id) => <button onClick={() => handleAccessDetails(id)}>Access Details</button> },
  ];
  const handleAccessDetails = (id) => {
    const encodedId = btoa(id);
    window.location.href = '/lead/sales-target/details/' + encodedId;
  };
  return <ListTemplate columns={columns} onAccessDetails={handleAccessDetails} fetchUrl={API_DOMAIN + API_ROUTES['salesTarget']} />;
};

export default SalesTargetListDetails;